import type { FC, ReactNode } from 'react';
import { Routes as RoutesRR } from 'react-router';

interface Props {
    children: ReactNode;
}

export const Routes: FC<Props> = ({ children }) => {
    return <RoutesRR>{children}</RoutesRR>;
};
